<pre class="text-container p-4 rounded-4">{{text.text}}</pre>
